import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import { styled } from '@classify/react-core-components/styles';
import MuiMenuItem from '@mui/material/MenuItem';
import Stack from '@classify/react-core-components/Stack';
import Typography from '@classify/react-core-components/Typography';
const StyledMuiMenuItem = styled(MuiMenuItem)(/* istanbul ignore next */({
  theme: {
    spacing,
    palette
  }
}) => ({
  '&.MuiMenuItem-root': {
    display: 'flex',
    paddingTop: spacing(1),
    paddingBottom: spacing(1),
    color: palette.text.onMain,
    '&:hover': {
      color: 'inherit'
    }
  }
}));
const MenuItem = forwardRef((t0, ref) => {
  const $ = _c(25);
  let label;
  let others;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    const {
      label: t4,
      caption: t5,
      data,
      icon: t6,
      rightIcon: t7,
      ...t8
    } = t0;
    label = t4;
    t1 = t5;
    t2 = t6;
    t3 = t7;
    others = t8;
    $[0] = t0;
    $[1] = label;
    $[2] = others;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    label = $[1];
    others = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const caption = t1 === undefined ? null : t1;
  const Icon = t2 === undefined ? null : t2;
  const RightIcon = t3 === undefined ? null : t3;
  let t4;
  if ($[6] !== Icon) {
    t4 = Icon && <Icon />;
    $[6] = Icon;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== label) {
    t5 = <Typography variant="body">{label}</Typography>;
    $[8] = label;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <Stack direction="row" gap={1}>{t4}{t5}</Stack>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== caption) {
    t7 = caption && <Typography variant="caption" component="div" sx={{
      whiteSpace: "initial"
    }}>{caption}</Typography>;
    $[13] = caption;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div>{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== RightIcon) {
    t9 = RightIcon && <RightIcon sx={{
      ml: "auto"
    }} />;
    $[18] = RightIcon;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== others || $[21] !== ref || $[22] !== t8 || $[23] !== t9) {
    t10 = <StyledMuiMenuItem component="a" ref={ref} {...others}>{t8}{t9}</StyledMuiMenuItem>;
    $[20] = others;
    $[21] = ref;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
});
export default MenuItem;